<template>
	<popup
		v-model="selfDisplay"
		title="下属机构"
		:confirmBtnDisplay="false"
	>
		<div v-loading="loading" style="padding: 15px;">
			<div class="base_table">
				<el-table
					:data="list"
					style="width: 100%"
				>
					<el-table-column
						prop="name"
						label="机构名称"
					>
					</el-table-column>
					<el-table-column
						prop="categoryLabel"
						label="企业类别"
					>
					</el-table-column>
					<el-table-column
						prop="time"
						label="创建时间"
					>
					</el-table-column>
				</el-table>
			</div>
		</div>
	</popup>
</template>

<script>
	import Api from '../../../../../api/index.js';
	
	export default {
		model: {
			prop: 'display',
			event: 'changeDisplay'
		},
		props: {
			display: Boolean,
			uid: {
				type: String,
				default: ''
			}
		},
		data () {
			return {
				selfDisplay: false,
				loading: false,
				list: []
			}
		},
		mounted () {
			this.display && (this.selfDisplay = true);
		},
		methods: {
			/*********************** @Function *************************/
			// 查询用户下属机构
			findUnderlingOrganizations() {
				const that = this;
				that.loading = true;
				let requestData = {
					userId: that.uid
				};
				Api.findUnderlingOrganizations(requestData).then((res) => {
					that.loading = false;
					if (res.data.success) {
						let list = [];
						let res_list = res.data.data || [];
						res_list.forEach(v => {
							list.push({
								id: v.uId,
								name: v.uName,
								categoryLabel: v.uCategory == 1 ? '代理' : '医院',
								time: v.uCreateTs
							});
						});
						that.list = list;
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			}
		},
		watch: {
			display(newValue) {
				this.selfDisplay = newValue;
			},
			selfDisplay(newValue) {
				this.$emit("changeDisplay", newValue);
				if (newValue) {
					this.findUnderlingOrganizations();
				} else {
					this.loading = false;
					this.list = [];
				}
			}
		}
	}
</script>

<style>
</style>
